<script>
import ListingsFailedOrder from "./Other/ListingsFailedOrder";
import ListingsNotServicing from "./Other/ListingsNotServicing";
import ListingsHistory from "./Other/ListingsHistory";
import ListingsUpgrade from "./Other/ListingsUpgrade";
import ListingsPreview from "./Other/ListingsPreview";

import ListingsSubmitYourListing from "./SubmitYourListing/ListingsSubmitYourListing";
import ListingsPropertyAddress from "./SubmitYourListing/ListingsPropertyAddress";
import ListingsListPrice from "./SubmitYourListing/ListingsListPrice";
import ListingsPackagesAndServices from "./SubmitYourListing/ListingsPackagesAndServices";
import ListingsAdditionalDetails from "./SubmitYourListing/ListingsAdditionalDetails";
import ListingsSubmitOrder from "./SubmitYourListing/ListingsSubmitOrder";

import ListingsEnterPropertyDetails from "./EnterPropertyDetails/ListingsEnterPropertyDetails";
import ListingsListingInputForm from "./EnterPropertyDetails/ListingsListingInputForm";

import ListingsPropertyPhotos from "./PropertyPhotos/ListingsPropertyPhotos";
import ListingsPhotoUploader from "./PropertyPhotos/ListingsPhotoUploader";

import ListingsDocumentSignatures from "./DocumentSignatures/ListingsDocumentSignatures";
import ListingsSignPaperwork from "./DocumentSignatures/ListingsSignPaperwork";

import ListingsListingActive from "./ListingActive/ListingsListingActive";
import ListingsListingComplete from "./ListingComplete/ListingsListingComplete";


export default {
  props: ['slug', 'website'],
  components: {
    ListingsFailedOrder,
    ListingsNotServicing,
    ListingsHistory,
    ListingsUpgrade,
    ListingsPreview,

    ListingsSubmitYourListing,
    ListingsPropertyAddress,
    ListingsListPrice,
    ListingsPackagesAndServices,
    ListingsAdditionalDetails,
    ListingsSubmitOrder,

    ListingsEnterPropertyDetails,
    ListingsListingInputForm,

    ListingsPropertyPhotos,
    ListingsPhotoUploader,

    ListingsDocumentSignatures,
    ListingsSignPaperwork,

    ListingsListingActive,

    ListingsListingComplete,
  },
  data() {
    return {
      page_tab: 0,
      default_total_tabs: 13,
      total_tabs: 13,
      lang: true,

      form_url: '',

      default_item: {
        user_id: '',
        mls_id: '',
        mls_title: '',
        ip_address: '',
        StandardStatus: 'Awaiting Order',
        PropertyType: 'Residential',
        PropertySubType: 'Single Family Residence',
        StreetNumber: '',
        StreetDirPrefix: '',
        StreetName: '',
        StreetSuffix: '',
        StreetDirSuffix: '',
        UnitNumber: '',
        Address: '',
        City: '',
        StateOrProvince: '',
        CountyOrParish: '',
        Country: 'United States',
        PostalCode: '',
        Longitude: '',
        Latitude: '',
        ListingContractDate	: '',
        ListPrice: 0.00,
        Ownership: '',
        YearBuilt: '',
        SeniorCommunityYN: '',
        AssociationYN: '',
        WaterSource: '',
        Electric: '',
        Sewer: '',
        LivingArea: '',
        LotSizeSquareFeet: '',
        LotSizeAcres: '',
        BedroomsTotal: '',
        BathroomsFull: '',
        BathroomsHalf: '',
        BathroomsOneQuarter: '',
        BathroomsPartial: '',
        BathroomsThreeQuarter: '',
        BathroomsTotalInteger: '',
        Stories: '',
        GarageSpaces: '',
        ParkingTotal: '',
        PoolFeatures: '',
        View: '',
        Heating: '',
        Cooling: '',
        Basement: '',
        PublicRemarks: '',
        Directions: '',
        CrossStreet: '',
        SubdivisionName: '',
        ListOfficeName: '',
        ListAgentFullName: '',
        ListOfficeEmail: '',
        ListOfficePhone: '',
        TaxYear: '',
        TaxAnnualAmount: '',
        PhotosCount: '',
        thumbnail: '',
        images: [],
        OwnerName: '',
        OwnerEmail: '',
        OwnerPhone: '',
        Owners: [],
        buying: '',
        is_realtor: '',
        has_realtor: '',
        referred_by: '',
        referred_name: '',
        packages_total: 0.00,
        savings_total: 0.00,
        estimated_total: 0.00,
        MailingAddress: '',
        MailingCity: '',
        MailingStateOrProvince: '',
        MailingPostalCode: '',
        active_package: {},
        active_services:[],
        additional_input: {},
        sign_company: {},
        valuations: [],
        cart: {
          to_name: '',
          to_address: '',
          to_city: '',
          to_state: '',
          to_zip_code: '',
          package:{},
          services:[],
        },
        user: {},
        carts: [],
        mls: {},
        payment_method_id: '',
        agree_terms: false,
        agree_cancellation: false,
        not_refundable: false,
      },
      item: {
        active_package: {},
        active_services:[],
        additional_input: {},
        sign_company: {},
        valuations: [],
        cart: {
          to_name: '',
          to_address: '',
          to_city: '',
          to_state: '',
          to_zip_code: '',
          package:{},
          services:[],
        },
        user: {},
        carts: [],
        mls: {},
      },

      loading: true,
      filters: {
        paginate: 1,
        page: 1,
        total: 0,
        wheres: {
          id: '',
        },
      },

      loading_packages: true,
      packages: [],

      loading_services: true,
      services: [],
    }
  },
  watch: {
    'item.StreetNumber': {handler: function(n, o) {
      this.item.Address = (
        (this.item.StreetNumber ? ' '+this.item.StreetNumber : '') +
        (this.item.StreetDirPrefix ? ' '+this.item.StreetDirPrefix : '') +
        (this.item.StreetName ? ' '+this.item.StreetName : '') +
        (this.item.StreetSuffix ? ' '+this.item.StreetSuffix : '') +
        (this.item.StreetDirSuffix ? ' '+this.item.StreetDirSuffix : '') +
        (this.item.UnitNumber ? ' '+this.item.UnitNumber : '')
      ).replace(/\s\s+/g, ' ').trim();
    }},
    'item.StreetDirPrefix': {handler: function(n, o) {
      this.item.Address = (
        (this.item.StreetNumber ? ' '+this.item.StreetNumber : '') +
        (this.item.StreetDirPrefix ? ' '+this.item.StreetDirPrefix : '') +
        (this.item.StreetName ? ' '+this.item.StreetName : '') +
        (this.item.StreetSuffix ? ' '+this.item.StreetSuffix : '') +
        (this.item.StreetDirSuffix ? ' '+this.item.StreetDirSuffix : '') +
        (this.item.UnitNumber ? ' '+this.item.UnitNumber : '')
      ).replace(/\s\s+/g, ' ').trim();
    }},
    'item.StreetName': {handler: function(n, o) {
      this.item.Address = (
        (this.item.StreetNumber ? ' '+this.item.StreetNumber : '') +
        (this.item.StreetDirPrefix ? ' '+this.item.StreetDirPrefix : '') +
        (this.item.StreetName ? ' '+this.item.StreetName : '') +
        (this.item.StreetSuffix ? ' '+this.item.StreetSuffix : '') +
        (this.item.StreetDirSuffix ? ' '+this.item.StreetDirSuffix : '') +
        (this.item.UnitNumber ? ' '+this.item.UnitNumber : '')
      ).replace(/\s\s+/g, ' ').trim();
    }},
    'item.StreetDirSuffix': {handler: function(n, o) {
      this.item.Address = (
        (this.item.StreetNumber ? ' '+this.item.StreetNumber : '') +
        (this.item.StreetDirPrefix ? ' '+this.item.StreetDirPrefix : '') +
        (this.item.StreetName ? ' '+this.item.StreetName : '') +
        (this.item.StreetSuffix ? ' '+this.item.StreetSuffix : '') +
        (this.item.StreetDirSuffix ? ' '+this.item.StreetDirSuffix : '') +
        (this.item.UnitNumber ? ' '+this.item.UnitNumber : '')
      ).replace(/\s\s+/g, ' ').trim();
    }},
    'item.StreetSuffix': {handler: function(n, o) {
      this.item.Address = (
        (this.item.StreetNumber ? ' '+this.item.StreetNumber : '') +
        (this.item.StreetDirPrefix ? ' '+this.item.StreetDirPrefix : '') +
        (this.item.StreetName ? ' '+this.item.StreetName : '') +
        (this.item.StreetSuffix ? ' '+this.item.StreetSuffix : '') +
        (this.item.StreetDirSuffix ? ' '+this.item.StreetDirSuffix : '') +
        (this.item.UnitNumber ? ' '+this.item.UnitNumber : '')
      ).replace(/\s\s+/g, ' ').trim();
    }},
    'item.UnitNumber': {handler: function(n, o) {
      this.item.Address = (
        (this.item.StreetNumber ? ' '+this.item.StreetNumber : '') +
        (this.item.StreetDirPrefix ? ' '+this.item.StreetDirPrefix : '') +
        (this.item.StreetName ? ' '+this.item.StreetName : '') +
        (this.item.StreetSuffix ? ' '+this.item.StreetSuffix : '') +
        (this.item.StreetDirSuffix ? ' '+this.item.StreetDirSuffix : '') +
        (this.item.UnitNumber ? ' '+this.item.UnitNumber : '')
      ).replace(/\s\s+/g, ' ').trim();
    }},
    'item.mls': {handler: function(n, o) {
      this.total_tabs = this.default_total_tabs + (this.item.mls.form_fields ? this.item.mls.form_fields.length : 0);
      console.log('changed total tabs to: '+this.total_tabs);
    }, deep: true},
  },
  computed: {
    estimatedSavings: function() {
      let savings = (3 / 100) * parseInt(this.item.ListPrice);
      savings = savings.toFixed(0);
      if(savings < 0) { savings = 0; }
      this.item.savings_total = savings;
      return savings;
    },
    estimatedTotal: function() {
      var total = 0;
      if(this.item.cart && this.item.cart.package && this.item.cart.package.price > 0) {
        total = total + parseFloat(this.item.cart.package.price);
      }
      if(this.item.cart && this.item.cart.services && this.item.cart.services.length > 0) {
        for(var i in this.item.cart.services) {
          if(this.item.cart.services[i].price > 0) {
            var service_price = (this.item.cart.services[i].quantity ? parseFloat(this.item.cart.services[i].price)*parseInt(this.item.cart.services[i].quantity) : parseFloat(this.item.cart.services[i].price));
            total = total + service_price;
          }
        }
      }
      this.item.estimated_total = total;
      return total;
    },
  },
  created() {
    if(this.slug && this.slug.slug_dynamic) {
      this.form_url = this.slug.slug_dynamic.replace('/:id','');
    } else if(this.slug && this.slug.slug) {
      this.form_url = this.slug.slug;
    } else {
      this.form_url = '/';
    }
    // console.log(this.slug);
    if(this.slug && this.slug.slug_id && this.slug.slug_id != 'new') {
      this.filters.wheres.id = this.slug.slug_id;
    }
    this.fetch_packages();
    this.fetch_services();

    window.onpopstate = res => {
      var urlParams = {}, match, pl = /\+/g, search = /([^&=]+)=?([^&]*)/g, decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); }, query  = window.location.search.substring(1);
      while (match = search.exec(query)) urlParams[decode(match[1])] = decode(match[2]);
      if(urlParams.tab && urlParams.tab < this.page_tab) { this.page_tab = urlParams.tab; }
    };
    
    if(this.slug && this.slug.slug_id && this.slug.slug_id != 'new') {
      this.fetchData();
    } else {
      if(this.user.id) { this.default_item.user_id = this.user.id; }
      // if(this.user.name) { this.default_item.OwnerName = this.user.name; }
      // if(this.user.phone) { this.default_item.OwnerPhone = this.user.phone; }
      // if(this.user.email) { this.default_item.OwnerEmail = this.user.email; }
      if(this.user.referred_by) { this.default_item.referred_by = this.user.referred_by; }
      if(this.user.referred_name) { this.default_item.referred_name = this.user.referred_name; }
      if(this.user.MailingAddress) { this.default_item.MailingAddress = this.user.MailingAddress; }
      if(this.user.MailingCity) { this.default_item.MailingCity = this.user.MailingCity; }
      if(this.user.MailingStateOrProvince) { this.default_item.MailingStateOrProvince = this.user.MailingStateOrProvince; }
      if(this.user.MailingPostalCode) { this.default_item.MailingPostalCode = this.user.MailingPostalCode; }
      if(this.user.BillingAddress) { this.default_item.cart.to_address = this.user.BillingAddress; }
      if(this.user.BillingCity) { this.default_item.cart.to_city = this.user.BillingCity; }
      if(this.user.BillingStateOrProvince) { this.default_item.cart.to_state = this.user.BillingStateOrProvince; }
      if(this.user.BillingPostalCode) { this.default_item.cart.to_zip_code = this.user.BillingPostalCode; }
      if(this.website.title) { this.default_item.ListOfficeName = this.website.title; }
      if(this.website.site_email) { this.default_item.ListOfficeEmail = this.website.site_email; }
      if(this.website.site_phone) { this.default_item.ListOfficePhone = this.website.site_phone; }

      this.item = JSON.parse(JSON.stringify(this.default_item));
      this.item.listings_count = 1;
      this.set_page(4);
    }
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http.get('/listings/fetchclient', {params: this.filters}).then(res => {
        console.log(res);
        
        this.loading = false;
        if(res.data.data.length == 1) {
          if(!res.data.data[0].additional_input || (res.data.data[0].additional_input && !res.data.data[0].additional_input.length == 0) || (res.data.data[0].additional_input && Object.keys(res.data.data[0].additional_input).length === 0)) {
            res.data.data[0].additional_input = {};
          }
          this.item = res.data.data[0];
          this.filters.total = res.data.total;
          this.cur_page();
        } else {
          window.alert('Listing could not be found. Redirecting.');
          window.location.replace(this.form_url);
        }
      }).catch(res => {
        this.loading = false;
        // this.popupErrors(res);
        window.alert('Listing could not be found. Redirecting.');
        window.location.replace(this.form_url);
      });
    },
    fetch_packages() {
      this.loading_packages = true;
      this.$http.get('/packages/fetch', {params: {paginate: 100, page: 1, total: 0}}).then(res => {
        // console.log(res);
        this.packages = res.data.data;
        this.loading_packages = false;
      }).catch(res => {
        this.loading_packages = false;
        // this.popupErrors(res);
        window.alert('There was an error loading the required data. Please try again and contact support if the problem persists. Redirecting.');
        window.location.replace(this.form_url);
      });
    },
    fetch_services() {
      this.loading_services = true;
      this.$http.get('/services/fetch', {params: {paginate: 100, page: 1, total: 0}}).then(res => {
        // console.log(res);
        this.services = res.data.data;
        this.loading_services = false;
      }).catch(res => {
        this.loading_services = false;
        // this.popupErrors(res);
        window.alert('There was an error loading the required data. Please try again and contact support if the problem persists. Redirecting.');
        window.location.replace(this.form_url);
      });
    },
    quantity_change(serv, serv_i) {
      this.item.cart.services[serv_i].quantity = Math.round(this.item.cart.services[serv_i].quantity);
      if(serv.quantity < 1) {
        if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
        var randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
        var removed = false;
        var n = new Noty({
          timeout: false,
          modal: true,
          type: 'alert', // alert, success, warning, error, info
          layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
          closeWith: ['button'], // click, button
          text: "Remove this item from the cart?",
          buttons: [
            Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> YES', 'btn btn-danger px-4 float-right ml-2', notyres => {
              var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
              if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
              this.item.cart.services.splice(serv_i, 1);
              removed = true;
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              n.close();
            }, {id: randomid, 'data-status': 'ok'}),
            Noty.button('NO', 'btn btn-light px-4 mr-2', notyres => {
              this.item.cart.services[serv_i].quantity = 1;
              n.close();
            }, {id: randomid+'_no', 'data-status': 'ok'}),
          ]
        }).show().on('onClose', () => { if(!removed) { this.item.cart.services[serv_i].quantity = 1; } this.dsbl_btn = false; });
      }
      if(serv.quantity > 99) { this.item.cart.services[serv_i].quantity = 99; }
    },
    cur_page() {
      if(this.item.StandardStatus == 'Awaiting Forms') {
        this.set_page(7);
      } else if(this.item.StandardStatus == 'Awaiting Photos') {
        this.set_page(8 + (this.item.mls.form_fields ? this.item.mls.form_fields.length : 0));
      } else if(this.item.StandardStatus == 'Awaiting Signatures') {
        this.set_page(10 + (this.item.mls.form_fields ? this.item.mls.form_fields.length : 0));
      } else if(this.item.StandardStatus == 'Awaiting Listing') {
        this.set_page(10 + (this.item.mls.form_fields ? this.item.mls.form_fields.length : 0));
      } else if([
        'Incomplete',
        'Coming Soon',
        'Active',
        'Active Under Contract',
        'Pending',
      ].includes(this.item.StandardStatus)) {
        this.set_page(12 + (this.item.mls.form_fields ? this.item.mls.form_fields.length : 0));
      } else if([
        'Delete',
        'Expired',
        'Hold',
        'Withdrawn',
        'Canceled',
        'Closed',
      ].includes(this.item.StandardStatus)) {
        this.set_page(13 + (this.item.mls.form_fields ? this.item.mls.form_fields.length : 0));
      } else {
        // this.$noty.warning("Listing is in an invalid stage.");
        // this.$router.push('/my-listings');
        window.alert('Listing is in an invalid stage. Redirecting.');
        window.location.replace(this.form_url);
      }
      // Awaiting Order
      // Awaiting Forms
      // Awaiting Photos
      // Awaiting Signatures
      // Awaiting Listing
      // Coming Soon
      // Active
      // Active Under Contract
      // Pending
      // Delete
      // Expired
      // Hold
      // Incomplete
      // Withdrawn
      // Canceled
      // Closed
      // Trash
    },
    set_page(page) {
      // this.calc_values();
      $("html, body").animate({scrollTop:"0px"});
      history.pushState({}, null, document.location.pathname+"?tab="+page);
      this.page_tab = page;
    },
  }
}
</script>

<template>
  <div class="">

    <div class="row m-0 _h-n-100vh-n-65">
      <div class="col-sm-12 col-md-3 col-lg-3 col-xl-2 p-0 bg-dark small">
        <div class="nav flex-column">
          <div v-if="item.StandardStatus == 'Awaiting Order'">
            <div class="nav-link py-3 border-bottom border-black" @click="page_tab > 1 ? set_page(1) : ''"
              :class="page_tab == 1 ? 'text-primary' : 'text-white'">
              <Icon :icon="page_tab > 1 ? 'fa:check-square-o' : 'fa:square-o'" class="text-white mr-2" />
              Submit your listing
            </div>
            <div class="nav-link py-3 pl-4 border-bottom border-black bg-darken-gray-900" @click="page_tab > 2 ? set_page(2) : ''"
              :class="page_tab == 2 ? 'text-primary' : 'text-white'">
              <Icon :icon="page_tab > 2 ? 'fa:check-square-o' : 'fa:square-o'" class="text-white mr-2" />
              Property address
            </div>
            <div class="nav-link py-3 pl-4 border-bottom border-black bg-darken-gray-900" @click="page_tab > 3 ? set_page(3) : ''"
              :class="page_tab == 3 ? 'text-primary' : 'text-white'">
              <Icon :icon="page_tab > 3 ? 'fa:check-square-o' : 'fa:square-o'" class="text-white mr-2" />
              List price
            </div>
            <div class="nav-link py-3 pl-4 border-bottom border-black bg-darken-gray-900" @click="page_tab > 4 ? set_page(4) : ''"
              :class="page_tab == 4 ? 'text-primary' : 'text-white'">
              <Icon :icon="page_tab > 4 ? 'fa:check-square-o' : 'fa:square-o'" class="text-white mr-2" />
              Packages and services
            </div>
            <div class="nav-link py-3 pl-4 border-bottom border-black bg-darken-gray-900" @click="page_tab > 5 ? set_page(5) : ''"
              :class="page_tab == 5 ? 'text-primary' : 'text-white'">
              <Icon :icon="page_tab > 5 ? 'fa:check-square-o' : 'fa:square-o'" class="text-white mr-2" />
              Additional details
            </div>
            <div class="nav-link py-3 pl-4 border-bottom border-black bg-darken-gray-900" @click="page_tab > 6 ? set_page(6) : ''"
              :class="page_tab == 6 ? 'text-primary' : 'text-white'">
              <Icon :icon="page_tab > 6 ? 'fa:check-square-o' : 'fa:square-o'" class="text-white mr-2" />
              Submit your listing
            </div>
          </div>
          <div v-else>
            <div class="nav-link py-3 border-bottom border-black text-white" v-tippy :content="'This section has been marked as complete and submitted to '+app_name">
              <Icon icon="fa:check-square-o" class="text-white mr-2" />
              Submit your listing
            </div>
          </div>

          <div v-if="[
            'Awaiting Forms',
          ].includes(item.StandardStatus)">
            <div class="nav-link py-3 border-bottom border-black" @click="item.StandardStatus == 'Awaiting Forms' ? set_page(7) : ''"
              :class="page_tab == 7 ? 'text-primary' : 'text-white'">
              <Icon :icon="page_tab > 7 ? 'fa:check-square-o' : 'fa:square-o'" class="text-white mr-2" />
              Enter property details
            </div>

            <div v-for="(page, page_i) in item.mls.form_fields" :key="page_i" :class="page_tab == 7 + (page_i + 1) ? 'text-primary' : 'text-white'" class="nav-link py-3 pl-4 border-bottom border-black bg-darken-gray-900">
              <Icon :icon="page_tab > 7 + (page_i + 1) ? 'fa:check-square-o' : 'fa:square-o'" class="text-white mr-2" />
              {{page.title}}
            </div>

          </div>
          <div v-else>
            <div class="nav-link py-3 border-bottom border-black text-white" v-tippy @show="() => item.StandardStatus != 'Awaiting Order'" :content="'This section has been marked as complete and submitted to '+app_name">
              <Icon :icon="item.StandardStatus != 'Awaiting Order' ? 'fa:check-square-o' : 'fa:square-o'" class="text-white mr-2" />
              Enter property details
            </div>
          </div>

          <div v-if="[
            'Awaiting Photos',
          ].includes(item.StandardStatus)">
            <div class="nav-link py-3 border-bottom border-black" @click="item.StandardStatus == 'Awaiting Photos' ? set_page(8 + (item.mls.form_fields ? item.mls.form_fields.length : 0)) : ''"
              :class="page_tab == 8 + (item.mls.form_fields ? item.mls.form_fields.length : 0) ? 'text-primary' : 'text-white'">
              <Icon :icon="page_tab > 8 + (item.mls.form_fields ? item.mls.form_fields.length : 0) ? 'fa:check-square-o' : 'fa:square-o'" class="text-white mr-2" />
              Property photos
            </div>
            <div class="nav-link py-3 pl-4 border-bottom border-black bg-darken-gray-900" @click="item.StandardStatus == 'Awaiting Photos' ? set_page(9 + (item.mls.form_fields ? item.mls.form_fields.length : 0)) : ''" style="background: #282e36"
              :class="page_tab == 9 + (item.mls.form_fields ? item.mls.form_fields.length : 0) ? 'text-primary' : 'text-white'">
              <Icon :icon="page_tab > 9 + (item.mls.form_fields ? item.mls.form_fields.length : 0) ? 'fa:check-square-o' : 'fa:square-o'" class="text-white mr-2" />
              Upload property photos
            </div>
          </div>
          <div v-else>
            <div class="nav-link py-3 border-bottom border-black text-white" v-tippy @show="() => item.StandardStatus != 'Awaiting Order' && item.StandardStatus != 'Awaiting Forms'" :content="'This section has been marked as complete and submitted to '+app_name">
              <Icon :icon="item.StandardStatus != 'Awaiting Order' && item.StandardStatus != 'Awaiting Forms' ? 'fa:check-square-o' : 'fa:square-o'" class="text-white mr-2" />
              Property photos
            </div>
          </div>

          <div v-if="[
            'Awaiting Signatures',
          ].includes(item.StandardStatus)">
            <div class="nav-link py-3 border-bottom border-black" @click="item.StandardStatus == 'Awaiting Signatures' ? set_page(10 + (item.mls.form_fields ? item.mls.form_fields.length : 0)) : ''"
              :class="page_tab == 10 + (item.mls.form_fields ? item.mls.form_fields.length : 0) ? 'text-primary' : 'text-white'">
              <Icon :icon="page_tab > 10 + (item.mls.form_fields ? item.mls.form_fields.length : 0) ? 'fa:check-square-o' : 'fa:square-o'" class="text-white mr-2" />
              Document signatures
            </div>
            <div class="nav-link py-3 pl-4 border-bottom border-black bg-darken-gray-900" @click="item.StandardStatus == 'Awaiting Forms' ? set_page(11 + (item.mls.form_fields ? item.mls.form_fields.length : 0)) : ''" style="background: #282e36"
              :class="page_tab == 11 + (item.mls.form_fields ? item.mls.form_fields.length : 0) ? 'text-primary' : 'text-white'">
              <Icon :icon="page_tab > 11 + (item.mls.form_fields ? item.mls.form_fields.length : 0) ? 'fa:check-square-o' : 'fa:square-o'" class="text-white mr-2" />
              Sign documents
            </div>
          </div>
          <div v-else>
            <div class="nav-link py-3 border-bottom border-black text-white" v-tippy @show="() => item.StandardStatus != 'Awaiting Order'" :content="'This section has been marked as complete and submitted to '+app_name">
              <Icon :icon="item.StandardStatus != 'Awaiting Order' && item.StandardStatus != 'Awaiting Forms' && item.StandardStatus != 'Awaiting Photos' ? 'fa:check-square-o' : 'fa:square-o'" class="text-white mr-2" />
              Document signatures
            </div>
          </div>

          <div>
            <div class="nav-link py-3 border-bottom border-black"
              :class="page_tab == 12 + (item.mls.form_fields ? item.mls.form_fields.length : 0) ? 'text-primary' : 'text-white'">
              <Icon :icon="[
                'Delete',
                'Expired',
                'Hold',
                'Withdrawn',
                'Canceled',
                'Closed',
                'Trash',
                'Coming Soon',
                'Incomplete',
                'Active',
                'Active Under Contract',
                'Pending',
              ].includes(item.StandardStatus) ? 'fa:check-square-o' : 'fa:square-o'" class="text-white mr-2" />
              Listing is live
            </div>
            <div class="nav-link py-3 border-bottom border-black"
              :class="page_tab == 13 + (item.mls.form_fields ? item.mls.form_fields.length : 0) ? 'text-primary' : 'text-white'">
              <Icon :icon="[
                'Delete',
                'Expired',
                'Hold',
                'Withdrawn',
                'Canceled',
                'Closed',
                'Trash',
              ].includes(item.StandardStatus) ? 'fa:check-square-o' : 'fa:square-o'" class="text-white mr-2" />
              Listing is complete
            </div>
          </div>
        </div>
      </div>
      <div class="col bg-white overflow-auto">
        <div class="py-2 border-bottom">
          <ul class="list-inline m-0 float-right">
            <li v-if="item.StandardStatus == 'Awaiting Order'" class="list-inline-item d-block d-md-inline-block m_f-right dropdown dropdown-hover">
              <div class="">
                <a class="nav-link p-2 ml-2 text-gray-800 text-hover-black" href="" role="button" data-toggle="dropdown" v-tippy content="Shopping Cart"><Icon icon="mdi:cart-outline" width="25" /></a>
                <div class="dropdown-menu dropdown-menu-right _w-n-400">
                  <div class="dropdown-item bg-light py-2"><h5 class="m-0">Package :</h5></div>
                  <div class="table-responsive">
                    <table class="table m-0 small">
                      <thead>
                        <tr>
                          <th>Item</th>
                          <th style="width: 10%">Quantity</th>
                          <th style="width: 10%" class="text-right">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="Object.keys(item.cart.package).length == 0">
                          <td colspan="3">None</td>
                        </tr>
                        <tr v-if="Object.keys(item.cart.package).length > 0">
                          <td>{{item.cart.package.title}} Package</td>
                          <td>1</td>
                          <td class="text-right">{{formatPrice(item.cart.package.price)}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="dropdown-item bg-light py-2"><h5 class="m-0">A La Carte services :</h5></div>
                  <div class="table-responsive">
                    <table class="table m-0 small">
                      <thead>
                        <tr>
                          <th>Item</th>
                          <th style="width: 10%">Quantity</th>
                          <th style="width: 10%" class="text-right">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="item.cart.services.length == 0">
                          <td colspan="3">None</td>
                        </tr>
                        <tr v-for="(serv, serv_i) in item.cart.services" :key="'b'+serv.id">
                          <td>{{serv.title}}</td>
                          <td v-if="!serv.once" class="p-1 align-middle">
                            <input type="number" class="form-control py-0 px-2 _h-30" v-model="serv.quantity" min="0" max="99" @change="quantity_change(serv, serv_i)">
                          </td>
                          <td v-else class="align-middle">{{serv.quantity}}</td>
                          <td class="text-right">{{formatPrice(serv.price * serv.quantity)}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="dropdown-item py-2 text-right font-weight-bold">Cart total:<span class="text-success ml-2">{{formatPrice(estimatedTotal)}}</span></div>
                </div>
              </div>
            </li>
            <li v-if="item.StandardStatus != 'Awaiting Order'" class="list-inline-item d-block d-md-inline-block m_f-right">
              <a class="nav-link p-2 ml-2 text-gray-800 text-hover-black" v-tippy content="Preview listing" @click="set_page('preview')"><Icon icon="ri:image-line" width="25" /></a>
            </li>
            <li v-if="item.StandardStatus != 'Awaiting Order'" class="list-inline-item d-block d-md-inline-block m_f-right">
              <a class="nav-link p-2 ml-2 text-gray-800 text-hover-black" v-tippy content="View order history" @click="set_page('history')"><Icon icon="mdi:clipboard-text-clock-outline" width="25" /></a>
            </li>
            <li class="list-inline-item d-block d-md-inline-block m_f-right dropdown dropdown-hover">
              <div class="">
                <a class="nav-link p-2 ml-2 text-gray-800 text-hover-black" href="" role="button" data-toggle="dropdown" v-tippy content="Help"><Icon icon="mdi:tooltip-question-outline" width="25" /></a>
                <div class="dropdown-menu dropdown-menu-right _w-n-300">
                  <div class="dropdown-item bg-light py-2"><h5 class="m-0">Email us:</h5></div>
                  <div class="dropdown-item py-2 text-muted">{{app_email}}</div>
                  <div class="dropdown-item bg-light py-2"><h5 class="m-0">Call us:</h5></div>
                  <div class="dropdown-item py-2 text-muted">{{formatPhone(app_phone)}}</div>
                </div>
              </div>
            </li>
            <li v-if="[
              'Awaiting Forms',
              'Awaiting Photos',
              'Awaiting Signatures',
              'Awaiting Listing',
              'Coming Soon',
              'Active',
              'Active Under Contract',
              'Pending',
              'Incomplete',
            ].includes(item.StandardStatus)" class="list-inline-item d-block d-md-inline-block m_f-right ml-sm-3">
              <button type="button" :class="'btn btn-sm small btn-'+website_id" v-tippy content="Purchase upgrades" @click="set_page('upgrade')"><Icon icon="mdi:gift-outline" width="16" /> Purchase upgrades</button>
            </li>
          </ul>
          <ul v-if="item.StandardStatus == 'Awaiting Order'" class="list-inline m-0 float-left small">
            <li class="list-inline-item d-block d-md-inline-block mr-5" v-tippy content="Your preferred list price. This can be updated in the 'List price' section."><div class="small text-muted">List price:</div><div class="font-weight-bold text-success">{{ formatPrice(item.ListPrice, true, false) }}</div></li>
            <li class="list-inline-item d-block d-md-inline-block mr-5" v-tippy content="Your estimated savings is 3% of your list price."><div class="small text-muted">Your savings:</div><div class="font-weight-bold text-success">{{ formatPrice(estimatedSavings, true, false) }}</div></li>
            <li class="list-inline-item d-block d-md-inline-block" v-tippy content="Total cost is the total of your shopping cart."><div class="small text-muted">Total cost:</div><div class="font-weight-bold text-success">{{ formatPrice(estimatedTotal, true, true) }}</div></li>
          </ul>
          <ul v-else class="list-inline m-0 float-left">
            <li class="list-inline-item d-block d-md-inline-block align-middle"><img :src="formatImage('/fm/revinre-nc/clip art/Real Estate Listings.png')" alt="" class="_w-35"></li>
            <li class="list-inline-item d-block d-md-inline-block align-middle">
              <h5 class="m-0">{{item.Address}}</h5>
              <small>{{item.City}} {{item.StateOrProvince}} {{item.PostalCode}}</small>
            </li>
          </ul>
          <div class="clearfix"></div>
        </div>

        <div class="progress _h-5"><div class="progress-bar progress-bar-striped progress-bar-animated" :style="'width:'+Math.round(page_tab/total_tabs*100)+'%'"></div></div>

        <div class="d-none text-right">
          <toggle-button class="mt-2" v-model="lang" :width="95" :labels="{checked: 'English', unchecked: 'Spanish'}" :color="{checked: '#3BAFDA', unchecked: '#DA623B'}" />
        </div>

        <transition name="fade" mode="out-in">

          <ListingsFailedOrder
            v-if="page_tab == 'failedorder'"
            :key="'failedorder'"
            @setpage="set_page"
            @curpage="cur_page"
          ></ListingsFailedOrder>
          <ListingsNotServicing
            v-if="page_tab == 'noservice'"
            :key="'noservice'"
            :item="item"
            @setpage="set_page"
            @curpage="cur_page"
          ></ListingsNotServicing>
          <ListingsHistory
            v-if="page_tab == 'history'"
            :key="'history'"
            :item="item"
            @setpage="set_page"
            @curpage="cur_page"
          ></ListingsHistory>
          <ListingsUpgrade
            v-if="page_tab == 'upgrade'"
            :key="'upgrade'"
            :item="item"
            :packages="packages"
            :services="services"
            @setpage="set_page"
            @curpage="cur_page"
          ></ListingsUpgrade>
          <ListingsPreview
            v-if="page_tab == 'preview'"
            :key="'preview'"
            :item="item"
            :packages="packages"
            :services="services"
            @setpage="set_page"
            @curpage="cur_page"
          ></ListingsPreview>

          <ListingsSubmitYourListing
            v-if="page_tab == 1"
            :key="1"
            :item="item"
            @setpage="set_page"
            @curpage="cur_page"
          ></ListingsSubmitYourListing>
          <ListingsPropertyAddress
            v-if="page_tab == 2"
            :key="2"
            :item="item"
            @setpage="set_page"
            @curpage="cur_page"
          ></ListingsPropertyAddress>
          <ListingsListPrice
            v-if="page_tab == 3"
            :key="3"
            :item="item"
            @setpage="set_page"
            @curpage="cur_page"
          ></ListingsListPrice>
          <ListingsPackagesAndServices
            v-if="page_tab == 4"
            :key="4"
            :item="item"
            :packages="packages"
            :services="services"
            @setpage="set_page"
            @curpage="cur_page"
          ></ListingsPackagesAndServices>
          <ListingsAdditionalDetails
            v-if="page_tab == 5"
            :key="5"
            :item="item"
            @setpage="set_page"
            @curpage="cur_page"
          ></ListingsAdditionalDetails>
          <ListingsSubmitOrder
            v-if="page_tab == 6"
            :key="6"
            :item="item"
            @setpage="set_page"
            @curpage="cur_page"
          ></ListingsSubmitOrder>

          <ListingsEnterPropertyDetails
            v-if="page_tab == 7"
            :key="7"
            :item="item"
            @setpage="set_page"
            @curpage="cur_page"
          ></ListingsEnterPropertyDetails>
          <ListingsListingInputForm
            v-for="(page, page_i) in item.mls.form_fields"
            v-if="page_tab == 7 + (page_i + 1)"
            :key="7 + (page_i + 1)"
            :item="item"
            :mls_page="page_i"
            :lang="lang"
            :admin="false"
            @setpage="set_page"
            @curpage="cur_page"
          ></ListingsListingInputForm>

          <ListingsPropertyPhotos
            v-if="page_tab == 8 + (item.mls.form_fields ? item.mls.form_fields.length : 0)"
            :key="8 + (item.mls.form_fields ? item.mls.form_fields.length : 0)"
            :item="item"
            @setpage="set_page"
            @curpage="cur_page"
          ></ListingsPropertyPhotos>
          <ListingsPhotoUploader
            v-if="page_tab == 9 + (item.mls.form_fields ? item.mls.form_fields.length : 0)"
            :key="9 + (item.mls.form_fields ? item.mls.form_fields.length : 0)"
            :item="item"
            :admin="false"
            @setpage="set_page"
            @curpage="cur_page"
          ></ListingsPhotoUploader>

          <ListingsDocumentSignatures
            v-if="page_tab == 10 + (item.mls.form_fields ? item.mls.form_fields.length : 0)"
            :key="10 + (item.mls.form_fields ? item.mls.form_fields.length : 0)"
            :item="item"
            @setpage="set_page"
            @curpage="cur_page"
          ></ListingsDocumentSignatures>
          <ListingsSignPaperwork
            v-if="page_tab == 11 + (item.mls.form_fields ? item.mls.form_fields.length : 0)"
            :key="11 + (item.mls.form_fields ? item.mls.form_fields.length : 0)"
            :item="item"
            @setpage="set_page"
            @curpage="cur_page"
          ></ListingsSignPaperwork>

          <ListingsListingActive
            v-if="page_tab == 12 + (item.mls.form_fields ? item.mls.form_fields.length : 0)"
            :key="12 + (item.mls.form_fields ? item.mls.form_fields.length : 0)"
            :item="item"
            @setpage="set_page"
            @curpage="cur_page"
          ></ListingsListingActive>

          <ListingsListingComplete
            v-if="page_tab == 13 + (item.mls.form_fields ? item.mls.form_fields.length : 0)"
            :key="13 + (item.mls.form_fields ? item.mls.form_fields.length : 0)"
            :item="item"
            @setpage="set_page"
            @curpage="cur_page"
          ></ListingsListingComplete>

        </transition>

        <div class="clearfix py-5">
          <!-- {{page_tab}} + {{(item.mls.form_fields ? item.mls.form_fields.length : 0)}} = {{page_tab + (item.mls.form_fields ? item.mls.form_fields.length : 0)}} -->
          <!-- <pre>{{item}}</pre> -->
        </div>

      </div>
    </div>

  </div>
</template>
